$(function () {
    // get a handle
    var foldTitle = $('.fold-title');

    foldTitle.on('click', function () {
        var parent = $(this).parents('.accordion-item');

        if (parent.hasClass('active')) {
            return false;
        }

        var parentAccordion = $(this).parents('.wt-accordion');

        var currentOpen = parentAccordion.find('.accordion-item.active');
        var content = currentOpen.find('.fold-content');

        currentOpen.removeClass('active');
        content.hide();

        // check if it is a horizontal accordion
        if (parentAccordion.hasClass('horizontal')) {

            var newContent = parent.find('.fold-content');

            newContent.css('display', 'flex');
        }
        // regular accordion
        else {

            var newContent = parent.find('.fold-content');

            newContent.css('display', 'flex');
            newContent.slideDown();
        }
        parent.addClass('active');
    });
});